import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import getConfig from '../../../config';
import { isNowPage } from '../../../helpers/now';
import isMobilePage from '../../../helpers/mobile';
import XM_LOGO_IMG from './constants';

const { homeDomain, xmMyAccountUrl } = getConfig();

const HIDE_BACK_PATHS = [
  '/confirmation',
  '/cancel-confirmation',
  '/auth-required',
  '/no-services',
  '/nocontact-error',
  '/bank',
  '/card',
  '/new-card',
  '/new-bank',
  '/method',
];
const ADD_BACK_URL_PATHS = ['/new'];

const BACK_URL = `https://${homeDomain}/billing/services`;
const DISMISS_LANDING_URL = `https://${homeDomain}/now`;

const { pathname } = window.location;
const isNow = isNowPage(pathname);
const isMobile = isMobilePage(pathname);

const shouldAddBackUrl = () => ADD_BACK_URL_PATHS
  .some(path => window.location.pathname === path);

const shouldHideBackButton = () => (
  window.history.length <= 1
  || HIDE_BACK_PATHS.some(endPath => window.location.pathname.endsWith(endPath))
);

const PolarisHeader = ({ user }) => {
  useEffect(() => {
    const interval = setInterval(() => {
      const logoLink = document.querySelector('a.xc-header--flownav-logo');
      if (logoLink && isMobile) {
        logoLink.href = xmMyAccountUrl;
        logoLink.innerHTML = XM_LOGO_IMG;
        logoLink.setAttribute('aria-label', 'Xfinity Mobile');
        logoLink.style = 'width: 124px;';
        clearInterval(interval);
      }
    }, 100);
    // Cleanup interval on unmount
    return () => clearInterval(interval);
  }, [isMobile]);

  return (
    <xc-header
      client-id="myAccountWeb"
      flownav
      auto-auth="true"
      enable-account-selector="1"
      {...(shouldHideBackButton() && { 'hide-back': true })}
      {...(shouldAddBackUrl() && { 'back-url': BACK_URL })}
      {...(isNow && (user?.nowAvailable || user?.now?.available) && { 'show-dismiss': true })}
      dismiss-landing-url={DISMISS_LANDING_URL}
    />
  );
};


const mapStateToProps = ({
  user: { user },
}) => ({ user });

export default connect(mapStateToProps, null)(PolarisHeader);
